module.exports = __webpack_public_path__ + "da7b68a6f212ea45e67e31bdd84bedd0.png";